import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import * as saveAs from 'file-saver';
import { HttpService } from 'src/app/service/http/http.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-dwmattachmentpopup',
  templateUrl: './dwmattachmentpopup.component.html',
  styleUrls: ['./dwmattachmentpopup.component.scss']
})
export class DwmattachmentpopupComponent implements OnInit {
  attachments: any[] = [];
  selectAllChecked = false;
  loggedInUserCompanyID: any;

  constructor(
    private dialogRef: MatDialogRef<DwmattachmentpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private config: Config,
    private httpService: HttpService,
    private encryptionService: EncryptionService,
    private httpClient: HttpClient
  ) {
    this.attachments = (data.attachments || []).map((file: any) => ({
      fileName: file,
      isChecked: false
    }));
    // console.log(this.attachments);
  }

  ngOnInit(): void {
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
  }

  /* ---------------- Select All ---------------- */
  toggleSelectAll(event: any): void {
    this.selectAllChecked = event.checked;
    this.attachments.forEach(a => (a.isChecked = this.selectAllChecked));
  }

  onCheckboxChange(): void {
    const allChecked = this.attachments.every(a => a.isChecked);
    const anyChecked = this.attachments.some(a => a.isChecked);
    this.selectAllChecked = allChecked;
  }

  /* ---------------- Download Single ---------------- */
  downloadSingle(file: any): void {
    const fileUrl = `${this.config.downloadDWMAttachment}/${file.fileName}`;
    // console.log("fileurl Single..",fileUrl)
    saveAs(fileUrl, file.fileName);
  }

  // ---------------------------------------------- Upload ------------------------------------------------
  downloadAttachment(fileName: string): void {
    if (!fileName) return;

    const url = `${this.config.downloadDWMAttachment}/${encodeURIComponent(fileName)}`;

    // (this.httpService as any).http.get(url, { responseType: 'blob' })
    // this.httpClient.get(url, {
    //     responseType: 'blob',
    //     headers: {
    //       Authorization: `Bearer ${sessionStorage.getItem("currentToken")}`
    //     }
    //   })
    this.httpService.getDwonloadBlobFile(url).subscribe({
      next: (blob: Blob) => {
        const objectUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(objectUrl);
      },
      error: () => {
        console.error('Download failed');
      }
    });
  }

  /* ---------------- Download Selected / All ---------------- */
  downloadSelected(): void {
    const selectedFiles = this.attachments.filter(a => a.isChecked);

    selectedFiles.forEach(file => {
      this.downloadAttachment(file.fileName);
    });
  }

  close(): void {
    this.dialogRef.close();
  }
  get hasAnySelected(): boolean {
    return this.attachments?.some(file => file.isChecked);
  }
}
